module.exports = __webpack_public_path__ + "img/wave.41898e94.svg";